// src/config/beatmaps.js

// 음악 BPM: 77.0
export const MUSIC_BPM = 77.0;

export const BEATMAPS = {
  easy: [
    { time: 1528, lane: 3, type: 'tap' },
    { time: 1918, lane: 2, type: 'tap' },
    { time: 2307, lane: 2, type: 'tap' },
    { time: 2697, lane: 3, type: 'tap' },
    { time: 3086, lane: 0, type: 'tap' },
    { time: 3476, lane: 1, type: 'tap' },
    { time: 3866, lane: 0, type: 'tap' },
    { time: 4255, lane: 2, type: 'tap' },
    { time: 4645, lane: 1, type: 'tap' },
    { time: 5034, lane: 1, type: 'tap' },
    { time: 5424, lane: 2, type: 'tap' },
    { time: 5814, lane: 3, type: 'tap' },
    { time: 6203, lane: 2, type: 'tap' },
    { time: 6593, lane: 2, type: 'tap' },
    { time: 6982, lane: 1, type: 'tap' },
    { time: 7372, lane: 1, type: 'tap' },
    { time: 7762, lane: 2, type: 'tap' },
    { time: 8151, lane: 1, type: 'tap' },
    { time: 8541, lane: 0, type: 'tap' },
    { time: 8931, lane: 1, type: 'tap' },
    { time: 9320, lane: 2, type: 'tap' },
    { time: 9710, lane: 0, type: 'tap' },
    { time: 10099, lane: 2, type: 'tap' },
    { time: 10489, lane: 0, type: 'tap' },
    { time: 10879, lane: 0, type: 'tap' },
    { time: 11268, lane: 0, type: 'tap' },
    { time: 11658, lane: 2, type: 'tap' },
    { time: 12047, lane: 0, type: 'tap' },
    { time: 12437, lane: 3, type: 'tap' },
    { time: 12827, lane: 0, type: 'tap' },
    { time: 13216, lane: 0, type: 'tap' },
    { time: 13606, lane: 2, type: 'tap' },
    { time: 13995, lane: 1, type: 'tap' },
    { time: 14385, lane: 0, type: 'tap' },
    { time: 14775, lane: 2, type: 'tap' },
    { time: 15164, lane: 3, type: 'tap' },
    { time: 15554, lane: 3, type: 'tap' },
    { time: 15944, lane: 0, type: 'tap' },
    { time: 16333, lane: 0, type: 'tap' },
    { time: 16723, lane: 0, type: 'tap' },
    { time: 17112, lane: 0, type: 'tap' },
    { time: 17502, lane: 2, type: 'tap' },
    { time: 17892, lane: 1, type: 'tap' },
    { time: 18281, lane: 2, type: 'tap' },
    { time: 18671, lane: 0, type: 'tap' },
    { time: 19060, lane: 2, type: 'tap' },
    { time: 19450, lane: 2, type: 'tap' },
    { time: 19840, lane: 1, type: 'tap' },
    { time: 20229, lane: 2, type: 'tap' },
    { time: 20619, lane: 2, type: 'tap' },
    { time: 21008, lane: 1, type: 'tap' },
    { time: 21398, lane: 0, type: 'tap' },
    { time: 21788, lane: 0, type: 'tap' },
    { time: 22177, lane: 0, type: 'tap' },
    { time: 22567, lane: 1, type: 'tap' },
    { time: 22957, lane: 3, type: 'tap' },
    { time: 23346, lane: 1, type: 'tap' },
    { time: 23736, lane: 2, type: 'tap' },
    { time: 24125, lane: 3, type: 'tap' },
    { time: 24515, lane: 1, type: 'tap' },
    { time: 24905, lane: 1, type: 'tap' },
    { time: 25294, lane: 2, type: 'tap' },
    { time: 25684, lane: 0, type: 'tap' },
    { time: 26063, lane: 3, type: 'tap' },
    { time: 26463, lane: 3, type: 'tap' },
    { time: 26853, lane: 1, type: 'tap' },
    { time: 27242, lane: 0, type: 'tap' },
    { time: 27632, lane: 2, type: 'tap' },
    { time: 28021, lane: 0, type: 'tap' },
    { time: 28411, lane: 1, type: 'tap' },
    { time: 28801, lane: 3, type: 'tap' },
    { time: 29190, lane: 2, type: 'tap' },
    { time: 29580, lane: 0, type: 'tap' },
    { time: 29970, lane: 2, type: 'tap' },
  ],
  normal: [
    { time: 1528, lane: 2, type: 'tap' },
    { time: 1723, lane: 0, type: 'tap' },
    { time: 2112, lane: 2, type: 'tap' },
    { time: 2307, lane: 1, type: 'tap' },
    { time: 2697, lane: 2, type: 'tap' },
    { time: 3671, lane: 2, type: 'tap' },
    { time: 3866, lane: 1, type: 'tap' },
    { time: 4255, lane: 2, type: 'tap' },
    { time: 4645, lane: 3, type: 'tap' },
    { time: 5229, lane: 0, type: 'tap' },
    { time: 5619, lane: 2, type: 'tap' },
    { time: 6203, lane: 2, type: 'tap' },
    { time: 6788, lane: 0, type: 'tap' },
    { time: 6788, lane: 1, type: 'tap' },
    { time: 7177, lane: 3, type: 'tap' },
    { time: 7372, lane: 2, type: 'tap' },
    { time: 7372, lane: 1, type: 'tap' },
    { time: 8151, lane: 0, type: 'tap' },
    { time: 8346, lane: 2, type: 'tap' },
    { time: 8736, lane: 0, type: 'tap' },
    { time: 8736, lane: 3, type: 'tap' },
    { time: 9320, lane: 1, type: 'tap' },
    { time: 9515, lane: 3, type: 'tap' },
    { time: 9710, lane: 2, type: 'tap' },
    { time: 9710, lane: 0, type: 'tap' },
    { time: 10294, lane: 2, type: 'tap' },
    { time: 10489, lane: 1, type: 'tap' },
    { time: 10879, lane: 0, type: 'tap' },
    { time: 11268, lane: 1, type: 'tap' },
    { time: 11853, lane: 3, type: 'tap' },
    { time: 12047, lane: 1, type: 'tap' },
    { time: 12242, lane: 2, type: 'tap' },
    { time: 12632, lane: 1, type: 'tap' },
    { time: 13021, lane: 3, type: 'tap' },
    { time: 13216, lane: 0, type: 'tap' },
    { time: 13411, lane: 2, type: 'tap' },
    { time: 13995, lane: 1, type: 'tap' },
    { time: 14190, lane: 2, type: 'tap' },
    { time: 14775, lane: 3, type: 'tap' },
    { time: 14970, lane: 2, type: 'tap' },
    { time: 15164, lane: 0, type: 'tap' },
    { time: 15554, lane: 1, type: 'tap' },
    { time: 16138, lane: 2, type: 'tap' },
    { time: 16333, lane: 0, type: 'tap' },
    { time: 16723, lane: 3, type: 'tap' },
    { time: 17112, lane: 0, type: 'tap' },
    { time: 17307, lane: 3, type: 'tap' },
    { time: 17697, lane: 2, type: 'tap' },
    { time: 17892, lane: 1, type: 'tap' },
    { time: 18086, lane: 0, type: 'tap' },
    { time: 18086, lane: 3, type: 'tap' },
    { time: 18671, lane: 0, type: 'tap' },
    { time: 18866, lane: 1, type: 'tap' },
    { time: 19450, lane: 0, type: 'tap' },
    { time: 19645, lane: 3, type: 'tap' },
    { time: 20034, lane: 1, type: 'tap' },
    { time: 20424, lane: 2, type: 'tap' },
    { time: 20619, lane: 0, type: 'tap' },
    { time: 20619, lane: 1, type: 'tap' },
    { time: 21203, lane: 1, type: 'tap' },
    { time: 21593, lane: 3, type: 'tap' },
    { time: 21788, lane: 1, type: 'tap' },
    { time: 21982, lane: 2, type: 'tap' },
    { time: 22177, lane: 0, type: 'tap' },
    { time: 22372, lane: 1, type: 'tap' },
    { time: 22957, lane: 3, type: 'tap' },
    { time: 23151, lane: 1, type: 'tap' },
    { time: 23736, lane: 2, type: 'tap' },
    { time: 23931, lane: 1, type: 'tap' },
    { time: 24125, lane: 3, type: 'tap' },
    { time: 24320, lane: 0, type: 'tap' },
    { time: 24710, lane: 1, type: 'tap' },
    { time: 24710, lane: 2, type: 'tap' },
    { time: 24905, lane: 0, type: 'tap' },
    { time: 25489, lane: 3, type: 'tap' },
    { time: 25684, lane: 1, type: 'tap' },
    { time: 25684, lane: 0, type: 'tap' },
    { time: 26073, lane: 3, type: 'tap' },
    { time: 26268, lane: 0, type: 'tap' },
    { time: 26463, lane: 1, type: 'tap' },
    { time: 26658, lane: 3, type: 'tap' },
    { time: 26853, lane: 0, type: 'tap' },
    { time: 27242, lane: 2, type: 'tap' },
    { time: 27437, lane: 0, type: 'tap' },
    { time: 27632, lane: 1, type: 'tap' },
    { time: 28216, lane: 0, type: 'tap' },
    { time: 28411, lane: 2, type: 'tap' },
    { time: 28801, lane: 1, type: 'tap' },
    { time: 28995, lane: 3, type: 'tap' },
    { time: 29580, lane: 1, type: 'tap' },
    { time: 29580, lane: 2, type: 'tap' },
  ],
  hard: [
    { time: 1528, lane: 3, type: 'tap' },
    { time: 1918, lane: 0, type: 'tap' },
    { time: 1918, lane: 3, type: 'tap' },
    { time: 2307, lane: 1, type: 'tap' },
    { time: 2697, lane: 1, type: 'tap' },
    { time: 2697, lane: 2, type: 'tap' },
    { time: 3086, lane: 3, type: 'tap' },
    { time: 3281, lane: 1, type: 'tap' },
    { time: 3281, lane: 0, type: 'tap' },
    { time: 3476, lane: 3, type: 'tap' },
    { time: 4060, lane: 0, type: 'tap' },
    { time: 4060, lane: 2, type: 'tap' },
    { time: 4450, lane: 2, type: 'tap' },
    { time: 4645, lane: 0, type: 'tap' },
    { time: 5034, lane: 0, type: 'tap' },
    { time: 5229, lane: 2, type: 'tap' },
    { time: 5424, lane: 0, type: 'tap' },
    { time: 5814, lane: 1, type: 'tap' },
    { time: 6008, lane: 2, type: 'tap' },
    { time: 6398, lane: 3, type: 'tap' },
    { time: 6593, lane: 2, type: 'tap' },
    { time: 6982, lane: 2, type: 'tap' },
    { time: 7177, lane: 1, type: 'tap' },
    { time: 7567, lane: 1, type: 'tap' },
    { time: 7762, lane: 0, type: 'tap' },
    { time: 8151, lane: 2, type: 'tap' },
    { time: 8346, lane: 3, type: 'tap' },
    { time: 8541, lane: 0, type: 'tap' },
    { time: 8736, lane: 2, type: 'tap' },
    { time: 8931, lane: 1, type: 'tap' },
    { time: 9320, lane: 2, type: 'tap' },
    { time: 9320, lane: 3, type: 'tap' },
    { time: 9515, lane: 0, type: 'tap' },
    { time: 9710, lane: 3, type: 'tap' },
    { time: 9905, lane: 2, type: 'tap' },
    { time: 10099, lane: 3, type: 'tap' },
    { time: 10489, lane: 0, type: 'tap' },
    { time: 10684, lane: 1, type: 'tap' },
    { time: 10879, lane: 2, type: 'tap' },
    { time: 11073, lane: 0, type: 'tap' },
    { time: 11463, lane: 3, type: 'tap' },
    { time: 11658, lane: 0, type: 'tap' },
    { time: 12047, lane: 1, type: 'tap' },
    { time: 12242, lane: 3, type: 'tap' },
    { time: 12632, lane: 3, type: 'tap' },
    { time: 13021, lane: 3, type: 'tap' },
    { time: 13411, lane: 2, type: 'tap' },
    { time: 13606, lane: 3, type: 'tap' },
    { time: 13801, lane: 2, type: 'tap' },
    { time: 14190, lane: 3, type: 'tap' },
    { time: 14385, lane: 1, type: 'tap' },
    { time: 14385, lane: 2, type: 'tap' },
    { time: 14580, lane: 3, type: 'tap' },
    { time: 14775, lane: 2, type: 'tap' },
    { time: 15164, lane: 2, type: 'tap' },
    { time: 15359, lane: 0, type: 'tap' },
    { time: 15554, lane: 1, type: 'tap' },
    { time: 15749, lane: 2, type: 'tap' },
    { time: 15749, lane: 0, type: 'tap' },
    { time: 15944, lane: 1, type: 'tap' },
    { time: 16138, lane: 2, type: 'tap' },
    { time: 16138, lane: 0, type: 'tap' },
    { time: 16333, lane: 3, type: 'tap' },
    { time: 16528, lane: 1, type: 'tap' },
    { time: 16723, lane: 0, type: 'tap' },
    { time: 16918, lane: 1, type: 'tap' },
    { time: 17112, lane: 0, type: 'tap' },
    { time: 17892, lane: 2, type: 'tap' },
    { time: 18476, lane: 1, type: 'tap' },
    { time: 18671, lane: 3, type: 'tap' },
    { time: 18866, lane: 0, type: 'tap' },
    { time: 19255, lane: 0, type: 'tap' },
    { time: 19255, lane: 2, type: 'tap' },
    { time: 19450, lane: 3, type: 'tap' },
    { time: 19645, lane: 0, type: 'tap' },
    { time: 20034, lane: 2, type: 'tap' },
    { time: 20229, lane: 1, type: 'tap' },
    { time: 20424, lane: 2, type: 'tap' },
    { time: 20424, lane: 3, type: 'tap' },
    { time: 20619, lane: 1, type: 'tap' },
    { time: 20814, lane: 2, type: 'tap' },
    { time: 21398, lane: 1, type: 'tap' },
    { time: 21593, lane: 2, type: 'tap' },
    { time: 21788, lane: 0, type: 'tap' },
    { time: 22177, lane: 2, type: 'tap' },
    { time: 22372, lane: 3, type: 'tap' },
    { time: 22567, lane: 0, type: 'tap' },
    { time: 22762, lane: 2, type: 'tap' },
    { time: 22762, lane: 1, type: 'tap' },
    { time: 23151, lane: 2, type: 'tap' },
    { time: 23346, lane: 1, type: 'tap' },
    { time: 23736, lane: 0, type: 'tap' },
    { time: 23931, lane: 1, type: 'tap' },
    { time: 24125, lane: 3, type: 'tap' },
    { time: 24320, lane: 0, type: 'tap' },
    { time: 24515, lane: 2, type: 'tap' },
    { time: 24905, lane: 1, type: 'tap' },
    { time: 25099, lane: 3, type: 'tap' },
    { time: 25294, lane: 1, type: 'tap' },
    { time: 25489, lane: 2, type: 'tap' },
    { time: 25684, lane: 3, type: 'tap' },
    { time: 25879, lane: 0, type: 'tap' },
    { time: 26268, lane: 1, type: 'tap' },
    { time: 26463, lane: 2, type: 'tap' },
    { time: 26463, lane: 0, type: 'tap' },
    { time: 26658, lane: 3, type: 'tap' },
    { time: 26853, lane: 2, type: 'tap' },
    { time: 27242, lane: 1, type: 'tap' },
    { time: 27632, lane: 3, type: 'tap' },
    { time: 27632, lane: 1, type: 'tap' },
    { time: 28021, lane: 0, type: 'tap' },
    { time: 28216, lane: 1, type: 'tap' },
    { time: 28606, lane: 2, type: 'tap' },
    { time: 28801, lane: 1, type: 'tap' },
    { time: 28995, lane: 0, type: 'tap' },
    { time: 29190, lane: 3, type: 'tap' },
    { time: 29385, lane: 0, type: 'tap' },
    { time: 29580, lane: 1, type: 'tap' },
  ],
}; 
